import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { Mail, Lock, LogIn, UserPlus, Leaf, Sun, Eye, EyeOff } from 'lucide-react'

function Auth() {
  const [isLogin, setIsLogin] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleAuth = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')

    try {
      if (isLogin) {
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        })
        if (error) throw error
      } else {
        if (password !== confirmPassword) {
          throw new Error('两次输入的密码不一致')
        }
        if (password.length < 6) {
          throw new Error('密码长度至少6位')
        }
        const { error } = await supabase.auth.signUp({
          email,
          password,
        })
        if (error) throw error
        setMessage('注册成功！请检查您的邮箱以验证账户。')
      }
    } catch (error) {
      setMessage(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full mb-6 shadow-xl shadow-green-300/40 animate-float">
            <Leaf className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-green-800 mb-3">烟草信息查询</h1>
          <p className="text-gray-600 text-lg">安全、高效的烟草产品信息管理平台</p>
        </div>

        <div className="bg-white/80 backdrop-blur-sm border border-green-200/60 rounded-3xl p-8 shadow-xl shadow-green-100/50">
          <div className="flex mb-8 bg-green-50/80 rounded-full p-1.5">
            <button
              onClick={() => { setIsLogin(true); setMessage(''); }}
              className={`flex-1 py-3 px-4 rounded-full font-medium transition-all duration-300 ${
                isLogin
                  ? 'bg-white text-green-700 shadow-md'
                  : 'text-gray-500 hover:text-green-600'
              }`}
            >
              登录
            </button>
            <button
              onClick={() => { setIsLogin(false); setMessage(''); }}
              className={`flex-1 py-3 px-4 rounded-full font-medium transition-all duration-300 ${
                !isLogin
                  ? 'bg-white text-green-700 shadow-md'
                  : 'text-gray-500 hover:text-green-600'
              }`}
            >
              注册
            </button>
          </div>

          <form onSubmit={handleAuth} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                邮箱地址
              </label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-400 w-5 h-5" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-white/80 backdrop-blur-sm border border-green-200/60 rounded-full py-4 pl-12 pr-4 text-gray-800 placeholder:text-green-300/70 focus:outline-none focus:ring-2 focus:ring-green-400/50 focus:border-green-400 focus:bg-white transition-all duration-300 hover:border-green-300"
                  placeholder="your@email.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                密码
              </label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-400 w-5 h-5" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-white/80 backdrop-blur-sm border border-green-200/60 rounded-full py-4 pl-12 pr-12 text-gray-800 placeholder:text-green-300/70 focus:outline-none focus:ring-2 focus:ring-green-400/50 focus:border-green-400 focus:bg-white transition-all duration-300 hover:border-green-300"
                  placeholder="••••••••"
                  required
                  minLength={6}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-green-400 hover:text-green-600 transition-colors"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {!isLogin && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  确认密码
                </label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-400 w-5 h-5" />
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full bg-white/80 backdrop-blur-sm border border-green-200/60 rounded-full py-4 pl-12 pr-12 text-gray-800 placeholder:text-green-300/70 focus:outline-none focus:ring-2 focus:ring-green-400/50 focus:border-green-400 focus:bg-white transition-all duration-300 hover:border-green-300"
                    placeholder="请再次输入密码"
                    required
                    minLength={6}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-green-400 hover:text-green-600 transition-colors"
                  >
                    {showConfirmPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>
            )}

            {message && (
              <div className={`p-4 rounded-2xl text-sm font-medium ${
                message.includes('成功') 
                  ? 'bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 border border-green-200/60'
                  : 'bg-gradient-to-r from-red-50 to-orange-50 text-red-700 border border-red-200/60'
              }`}>
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-green-400 to-emerald-500 text-white font-semibold rounded-full py-4 flex items-center justify-center gap-2 shadow-lg shadow-green-300/40 transition-all duration-300 hover:shadow-xl hover:shadow-green-300/50 hover:scale-105 hover:from-green-500 hover:to-emerald-600 disabled:opacity-50 disabled:hover:scale-100"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-white"></div>
              ) : (
                <>
                  {isLogin ? <LogIn className="w-5 h-5" /> : <UserPlus className="w-5 h-5" />}
                  <span>{isLogin ? '登录' : '注册'}</span>
                </>
              )}
            </button>
          </form>

          <div className="mt-8 text-center text-sm text-gray-500">
            <p>首次使用请先注册账户</p>
            <p className="mt-1 text-gray-400">管理员权限需要联系系统管理员分配</p>
          </div>
        </div>

        <div className="mt-8 bg-gradient-to-br from-green-50/80 via-emerald-50/50 to-amber-50/30 border border-green-200/60 rounded-2xl p-6 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-green-200/30 to-transparent rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="flex items-center gap-3 mb-3 relative">
            <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full">
              <Sun className="w-4 h-4 text-white" />
            </div>
            <span className="font-medium text-green-800">功能特点</span>
          </div>
          <ul className="space-y-2 text-sm text-gray-600 relative">
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-green-400 rounded-full"></span>
              条码扫描快速查询
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-amber-400 rounded-full"></span>
              多关键词智能搜索
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-sky-400 rounded-full"></span>
              产品详情完整展示
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Auth
